import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "gatsby"
import { css } from "@emotion/react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Categorys from "../components/Categorys"
import Icon from "../components/icon/Icon"
import styled from "styled-components"
import { sp } from "../styles/media"
import { Color } from "../styles/color"
import { Pagination, pageNationFormula } from "@thunder_fury/react-components"
import { Pagenation } from '../styles/block'
import Posts from "../components/Post"
export interface BlogIndexProps {
  location?: any
  upperPageBound?: number
  backgroundColor?: string
  postsPerList?: number
  firstAndLast?: boolean
  borderRound?: number
}

const Item = styled.div`
  margin-top: 20px;
`
export const BlogIndex: React.FC<BlogIndexProps> = ({ location }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
      allContentfulPost {
        edges {
          node {
            tags {
              name
              slug
              img {
                file {
                  url
                }
              }
            }
            image {
              file {
                url
              }
            }
            title
            slug
            author
            content {
              childMarkdownRemark {
                html
                excerpt(pruneLength: 100)
              }
            }
            updatedAt(formatString: "YYYY.MM.DD")
            createdAt(formatString: "YYYY.MM.DD")
          }
        }
      }
    }
  `)
  const siteTitle = data.site.siteMetadata.title
  const blogData = data.allContentfulPost.edges
  const [currentPage, setCurrentPage] = useState(1)
  const pageInfo: { [key: string]: number } = pageNationFormula(
    blogData,
    currentPage,
    5,
    1
  )
  const paginate: (pageNumber: number) => void = (pageNumber: number) =>
    setCurrentPage(pageNumber)
  const currentPosts: any = pageInfo.currentPosts
  return (
    <Layout location={location} title={siteTitle}>
      <SEO title="All posts" />
      <ArticleList.container>
        <Pagenation.articles>
          <Posts posts={currentPosts} />
          <Pagenation.numbers>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              paginate={paginate}
              totalPage={pageInfo.totalPage}
              startPage={pageInfo.startPage}
              endPage={pageInfo.endPage}
              upperPageBound={1}
              backgroundColor={`${Color.black}`}
              firstAndLast={true}
              borderRound={20}
            />
          </Pagenation.numbers>
        </Pagenation.articles>
      </ArticleList.container>
    </Layout>
  )
}
const ArticleList = {
  container: styled.div`
    max-width: 700px;
    width: 100%;
    margin: 20px auto 0;
  `,
}

export default BlogIndex
